export default "__VITE_PUBLIC_ASSET__4a91fdaa__"